import gsap from "gsap";

class ScrollTo {
  constructor(link) {
    this.link = link;
    this.target = document.querySelector(this.link.getAttribute("href"));
    this.init();
  }

  init() {
    this.link.addEventListener("click", (e) => {
      e.preventDefault();

      let targetPosition;
      if (window.innerWidth >= 1200) {
        targetPosition =
          document.documentElement.scrollHeight - window.innerHeight;
      } else {
        targetPosition = this.target.offsetTop;
      }

      gsap.to(document.documentElement, {
        scrollTop: targetPosition,
        duration: 0.5,
        ease: "power2.inOut",
      });
    });
  }
}

export default ScrollTo;
